import TextArea from 'antd/es/input/TextArea';
import MyInput from '../../../components/ui/MyInput';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import UploadImgPublish from '../../../components/ui/UploadImgPublish';
import Toggle from '../../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/Toggle';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { translate } from '../../../utils/language';
import systemSlice from '../../../redux/systemSlice';
const ArrayOf4 = Array.from({ length: 5 });

const Images = ({ imagesFormButtonRef, data, setData, onSave }) => {
  const [isOpen, setIsOpen] = useState(false);
  const app = useSelector(state => state.myAppsSlice?.localReduxData.app);
  const dispatch = useDispatch();
  const initialImagesData = {
    appLogo: app?.appLogo,
    googlePlayPlaceholder: '',
    splashScreen: '',
    placeholderImage: '',
    storePreviewImages: [],
  }
  const [imagesData, setImagesData] = useState(initialImagesData);

  const updateImages = (key, value) => {
    setImagesData(state => ({ ...state, [key]: value }));
  };

  useEffect(() => {

    const newImagesData = { ...initialImagesData }
    Object.keys(data).map(key => {
      if (key in initialImagesData && data[key]) {
        newImagesData[key] = data[key]
      }
    })

    setImagesData(newImagesData)
  }, [])

  const defaultCustomImages = ArrayOf4.map((_, index) => {
    return (
      <div className="flex-1">
        <UploadImgPublish
          accept={{
            'image/png': ['.png'],
          }}
          output={{ width: 1242, height: 2688 }}
          preImage={imagesData.storePreviewImages[index]}
          boxHeight={292.175}
          boxWidth={135}
          imageWidth="120"
          imageHeight="120"
          onChange={e => {
            setImagesData(state => {
              const newState = { ...state };
              const storePreviewImages = newState.storePreviewImages;
              storePreviewImages[index] = e;
              newState.storePreviewImages = storePreviewImages;
              return newState;
            });
          }}
          label=""
          placeholder=""
          text={''}
          obJectFit={'cover'}
          error={'error'}
          uploadType={2}
          resolution={'1242x2688'}

        />
      </div>
    );
  });

  return (
    <form
      className="flex flex-col gap-[20px] p-[20px] "
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        const { appLogo, splashScreen, placeholderImage, storePreviewImages, googlePlayPlaceholder } = imagesData;
        if (
          !appLogo ||
          !splashScreen ||
          !placeholderImage ||
          (isOpen && storePreviewImages?.length < 3) ||
          !googlePlayPlaceholder
        ) {
          dispatch(systemSlice.actions.setToastError({ detail: translate('missingPublishImages') }));
          return;
        }
        setData(state => ({ ...state, images: imagesData }));
        onSave();
      }}
    >
      <div className="flex flex-col gap-[20px] flex-wrap">
        <div className="flex flex-row w-full gap-[40px]">
          <div className=" flex flex-col gap-[10px] w-full">
            <div className=" flex flex-row gap-[10px] w-full justify-between">
              <div className="flex flex-col gap-[10px]">
                <div>Google Placeholder</div>

                <UploadImgPublish
                  accept={{
                    'image/png': ['.png'],
                  }}
                  required
                  output={{ width: 1024, height: 500 }}
                  preImage={imagesData?.googlePlayPlaceholder}
                  boxHeight={250}
                  boxWidth={512}
                  onChange={e => {
                    updateImages('googlePlayPlaceholder', e);
                  }}
                  label=""
                  placeholder=""
                  text={''}
                  obJectFit={'cover'}
                  error={'error'}
                  uploadType={2}
                  resolution={'1024x512'}
                  imageText={'*Görsel tam istenilen boyutta olmalıdır'}
                />
              </div>
              <div className="flex flex-col gap-[10px]">
                <div>Uygulama Ikonu</div>

                <UploadImgPublish
                  accept={{
                    'image/png': ['.png'],
                  }}
                  required
                  output={{ width: 1024, height: 1024 }}
                  preImage={imagesData?.appLogo}
                  boxHeight={250}
                  boxWidth={250}
                  onChange={e => {
                    updateImages('appLogo', e);
                  }}
                  label=""
                  placeholder=""
                  text={''}
                  obJectFit={'cover'}
                  error={'error'}
                  uploadType={2}
                  resolution={'1024x1024'}
                  imageText={'*Görsel tam istenilen boyutta olmalıdır'}
                />
              </div>
            </div>
            <div>Uygulama Mağazası Önizleme Görselleri</div>
            <Toggle
              value={isOpen}
              setItem={() => {
                setIsOpen(state => !state);
              }}
              targetKey={'uploadCustomStoreImage'}
            />
            <div className="flex flex-row gap-[20px] flex-wrap">
              {isOpen ? (
                defaultCustomImages
              ) : (
                <div className="text-sm pt-[10px] py-2 text-[#8A92A6] text-[15px] font-medium">
                  Uygulama Mağazası Önizleme Görselleri otomatik olarak oluşturulacaktır.
                </div>
              )}
            </div>
          </div>
          <div className=" flex flex-col gap-[10px] w-[250px] shrink-0">
            <div className="flex flex-col gap-[10px]">
              <div>Placeholder</div>

              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                required
                preImage={imagesData.placeholderImage}
                output={{ width: 1024, height: 1024 }}
                boxHeight={250}
                boxWidth={250}
                onChange={e => {
                  updateImages('placeholderImage', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1024x1024'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
            <div className="flex flex-col gap-[10px]">
              <div>Uygulama Açılış Görseli</div>

              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                output={{ width: 1290, height: 2796 }}
                preImage={imagesData.splashScreen}
                boxHeight={541.86}
                boxWidth={250}
                onChange={e => {
                  updateImages('splashScreen', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1090x2796'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
          </div>
        </div>
      </div>

      <button className="hidden" ref={imagesFormButtonRef} type="submit"></button>
    </form>
  );
};

export default Images;
